import IEditRegionRequest from "interfaces/Request/IEditRegionRequest";
import { GlobalState } from "little-state-machine";

export const updateEditRegionRequest = (
  state: GlobalState,
  editRegionRequest: IEditRegionRequest
) => ({
  ...state,
  editRegionRequest
});
